import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getMazdaScopeLabel = (scope: string | Nullish) =>
  match(scope)
    .when(isNil, always(undefined))
    .with('warranty', always(i18n.t('entity.orderIntegration.labels.scopeWarranty')))
    .with('goodwill', always(i18n.t('entity.orderIntegration.labels.scopeGoodwill')))
    .with('tsc', always(i18n.t('entity.orderIntegration.labels.scopeTsc')))
    .otherwise((value) => value);
